import { useEffect, useState, type CSSProperties } from 'react';
import './deslizador.css';

/**
 * RV Cifra (componentes.md, microinteracciones): cada dígito es una columna 0–9 que se desplaza hasta su valor (560 ms);
 * cifras tabulares. Rueda desde 0 la primera vez. Solo para cifras que da la API (G121, G140: nunca contadas por el
 * panel). El número se lee entero para lectores de pantalla.
 */
export function Cifra({ valor, tamano = 28, peso = 800, style }: { valor: number; tamano?: number; peso?: number; style?: CSSProperties }) {
    const texto = valor.toLocaleString('es-ES');
    const [mostrado, setMostrado] = useState(() => texto.replace(/\d/g, '0'));
    useEffect(() => {
        const t = setTimeout(() => {
            setMostrado(texto);
        }, 20);
        return () => {
            clearTimeout(t);
        };
    }, [texto]);
    const caracteres = (mostrado.length === texto.length ? mostrado : texto).split('');
    return (
        <span className="rv-cifra" style={{ fontSize: tamano, fontWeight: peso, ...style }}>
            <span className="rv-solo-lector">{texto}</span>
            <span aria-hidden="true" style={{ display: 'inline-flex' }}>
                {caracteres.map((c, i) =>
                    /\d/.test(c) ? (
                        <span key={i} className="rv-cifra__col">
                            <span className="rv-cifra__rueda" style={{ transform: `translateY(-${String(Number(c) * 10)}%)` }}>
                                {'0123456789'.split('').map((d) => (
                                    <span key={d}>{d}</span>
                                ))}
                            </span>
                        </span>
                    ) : (
                        <span key={i}>{c}</span>
                    ),
                )}
            </span>
        </span>
    );
}
